import styled from 'styled-components';

export const KpiSetCreateWrapper = styled.div`

.ReactTable .rt-table {
    text-align: center;
  }
.sc-eqIVtm.eMfiKS{
    width:100%;
}
  .new-kpi-col-manage .bg-white {
    border-radius: 6px;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 30, 0.1), 0 4px 8px 0 rgba(0, 0, 30, 0.1), 0 0 2px 0 rgba(0, 0, 30, 0.1);
    padding: 0px;
}

.new-kpi-col-manage .add-tab-bg {
    height: 167px;
    border-radius: 5px;
    border: solid 1px #4a90e2;
    background-color: rgba(74, 144, 226, 0.09);
    position: relative;
    cursor: pointer;
}
.new-kpi-col-manage .add-tab-bg .lever-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    text-align: center;
    margin-top: -34px;
    margin-left: -51px;
}
.new-kpi-col-manage .add-tab-bg .lever-icon i {
    color: #083ac8;
    font-size: 40px;
}
.new-kpi-col-manage .add-tab-bg .lever-icon span {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: normal;
    color: #4a90e2;
}

.new-kpi-col-manage .bg-white .form-group .form-control {
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    letter-spacing: 0.5px;
    color: #73818f;
    height: 34px;
    border-radius: 4px;
    border: solid 1px #c8ced3;
}
.new-kpi-col-manage .kpi-heading {
    margin: 20px 0;
}
.new-kpi-col-manage .kpi-heading h2 {
    font-size: 18px;
    font-weight: 400;
    letter-spacing: 0.01px;
    color: #708393;
    margin-top: 8px;
}
.new-kpi-col-manage .kpi-heading .kpi-btn a {
    font-size: 14px;
    font-weight: 400;
    color: #4a90e2;
    margin-right: 20px;
}
.new-kpi-col-manage .kpi-heading .kpi-btn .btn {
    width: 140px;
    height: 36px;
    border-radius: 4px;
    border: solid 1px #083ac8;
    background-color: #083ac8;
    color: #fff;
    font-size: 13px;
    font-weight: 700;
    text-transform: uppercase;
    text-align: center;
}
.new-kpi-col-manage .kpi-heading .kpi-btn .btn:hover {
    border: solid 1px #333;
    background-color: #333;
}
.new-kpi-col-manage .bg-white .control-lever .badge {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.2px;
    color: #434343;
    text-align: center;
    padding: 7px 20px;
    margin-top: 20px;
    margin-bottom: 10px;
}
.new-kpi-col-manage{
    width: 606px;
    margin: 0 15px;
}
.drop-form-control select {
    -webkit-appearance: none;
    padding-right: 40px;
    background-repeat: no-repeat;
    background-position: 96%;
    
}
.table-section-new .drop-form-control select {
    border-radius:30px;
}
.drop-form-control .input-group-prepend i {
    color: #73818f;
    font-weight: 100;
}
.dateControl-class-kpinew {
    border-radius: 4px !important;
    border: solid 1px #c8ced3 !important;
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
}
.topbox-arrow {
    width: 38px;
    height: 34px;
    border-radius: 4px;
    border: solid 1px #083ac8;
    background-color: #083ac8;
    position: relative;
    cursor: pointer;
    margin: 0 auto;
}
.topbox-arrow:before {
    content: "";
    position: absolute;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 10px solid #fff;
    top: 10px;
    left: 11px;
}
.smallp {
    font-size: 11px !important;
    font-weight: normal !important;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.18;
    letter-spacing: 0.1px !important;
    color: rgba(0, 0, 0, 0.6) !important;
}
.del-field button {
    outline: none;
}
.del-field i {
    opacity: 0.5;
    color: #00001e;
}
.new-kpi-col-manage .bg-white .control-lever .badge-warning {
    background-color: #ffebb2;
}
.new-kpi-col-manage .bg-white .control-lever .badge-info {
    background-color: #e7f6fa;
}
.new-kpi-col-manage .card-header{
	padding: .75rem 1.25rem;
    margin-bottom: 0;
    background-color: #f0f3f5;
    border-bottom: 1px solid #c8ced3;
}
.new-kpi-col-manage .card-body {
    padding: 1.25rem 25px;
}
.heading{
    font-size: 23px;
    font-weight: 700;
    letter-spacing: 0.33px;
    color: #000000;
    margin-bottom: 20px;
}
.manage-createKPI label{
	font-size: 14px;
    font-weight: 600;
    line-height: 1.71;
    letter-spacing: 0.13px;
    color: #2f353a;
}
.card-text-mange-create{
	font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1;
    letter-spacing: 0.2px;
    color: #000000;
    margin-top: 0px;
}
.add-userlabel{
	margin-top:0;
	margin-bottom:15px;
	font-size:20px;
}
.managebox {
    width: 100%;
    height: 200px;
    border-width: 1px;
    border-style: solid;
    border-color: 
    #979797;
    border-image: initial;
    overflow: auto;
    padding: 10px 10px;
    display: inline-block;
    vertical-align: top;
}

.managebox .custom-checkbox .custom-control-label::before {
    border-radius: 3px;
}
.managebox .custom-control-label::before{
    width:13px;
    height:13px;
    border-radius: 3px;
    top:1px;
}
.managebox .custom-control-label::after{
    width:12px;
    height:12px;
    border-radius: 3px;
}
/* .managebox .custom-control{ */
    /* min-height: 16px; */
/* } */
.managebox .custom-control-label{
    line-height: 16px !important;
    font-weight: normal !important;
}
.line-height20px{
    line-height: 20px !important;
}
.custom-control-input:checked ~ .custom-control-label::before{
    border:#c8ced3 solid 1px;
    background: none;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
    left: -20px;
    top: 2px;
    width: 5px;
    height: 8px;
    border: solid #0070d2;
    border-top-width: medium;
    border-right-width: medium;
    border-bottom-width: medium;
    border-left-width: medium;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label-big::after {
    left: -19px;
    top: 6px;
    width: 6px;
    height: 10px;
}
.select-all-label{
	color:#000 !important;
	font-weight:normal !important;
}
.select-all-label:before{
	width:14px;
	height:14px;
}
.mang-kpibtn .btn-primary{
  width: 118px;
  height: 40px;
  border-radius: 5px;
  background-color: #083ac8;
  color:#fff;
  font-size:14px;
}
.mang-kpibtn .btn-link{
	color: #083ac8;
	
}
.mt-125px{
	margin-top:125px;
}
.search-container {
    position: relative;
}
.search-container input {
    padding: 6px;
    font-size: 13px;
    font-weight: 400;
    line-height: 1.85;
    letter-spacing: 0.12px;
    color: rgba(0, 0, 0, 0.6);
    height: 38px;
    border: solid 1px rgb(206, 212, 218);
    background-color: #fff;
    width: 264px;
    border-radius: 4px;
}
.search-container button {
    background: transparent;
    font-size: 17px;
    border: none;
    position: absolute;
    right: 4px;
    top: 3px;
    color: #54698d;
    outline: none;
}
.input-search-mange-create{
    width:100% !important;
    border-radius:20px !important;
    outline:none;
}
.manage-create-table .table-striped {
    border: 1px solid #dee2e6;
}
.left-sidesearch-pannel {
    padding: 30px 0 10px 0;
    /*background: #efefef;*/
}
.bs-example .card-header{
    margin-bottom:0;
    padding:0;
    background-color:#fff;
}
.bs-example .card-header button {
    padding: 9px 5px;
    font-size: 14px;
    color: #333;
    font-weight: 4
    00;
    width: 100%;
    text-align: left;
    text-decoration:none;
}
.bs-example .card-header button .fa{
    float:right;
    margin-top:4px;
    font-size:13px;
}
.custom-checkbox .custom-control-input:checked ~ .select-all-label::after {
    left: -19px !important;
    top: 6px !important;
}
.user-table .rt-thead.-header{
    padding:10px 0;
}

ul, #myUL {
    list-style-type: none;
}
#myUL {
    margin: 0;
    padding: 0;
}
.caret {
    cursor: pointer;
    -webkit-user-select: none; /* Safari 3.1+ */
    -moz-user-select: none; /* Firefox 2+ */
    -ms-user-select: none; /* IE 10+ */
    user-select: none;
}
    .caret::before {
        content: "\f055";
        color: black;
        display: inline-block;
        margin-right: 6px;
        font-family: 'Font Awesome\ 5 Free';
        color: #c8c9cb;
        font-size:16px;
    }
.caret-down::before {
    content: "\f056";
    font-family: 'Font Awesome\ 5 Free';
    font-size: 16px;
}
.nested {
    display: none;
}
.active {
    display: block;
}
.tree-cardbody{
    padding:5px 15px !important;
}
.tree-cardbody .caret {
    font-size: 13px;
    font-weight: 600;
    color: #333;
    line-height: 30px;
}
.for-treeviewchkbox:before {
    width: 13px !important;
    height: 13px !important;
}
.custom-checkbox .custom-control-input:checked ~ .for-treeviewchkbox::after {
    top: 5px !important;
}
.for-treeviewchkbox {
    font-size: 13px !important;
    font-weight: normal !important;
}
.li-open-arrow {
    position: relative;
}
.li-open-arrow:before {
    border-left: 1px solid #dadada;
    bottom: 50px;
    height: 100%;
    top: -10px;
    width: 1px;
    position: absolute;
    content: '';
    left: -13px;
}
.li-open-arrow:after {
    border-top: 1px solid #dadada;
    height: 20px;
    top: 10px;
    width: 12px;
    position: absolute;
    content: "";
    left: -12px;
}
.nested {
    padding-left: 20px;
}
.posabsolut-secondtable {
    position: absolute;
    left: 18px;
    right: 0;
    top: -3px;
}
.list-style-disc{
    list-style:disc;
}
@media (max-width: 991px) {
    .width70tab{
width:70% !important;
}
.smallp {
    text-align: left !important;
    line-height: initial;
}
}
@media (max-width: 767px) {
.new-kpi-col-manage{
    margin-left: 0;
    margin-right: 0;
    padding: 0 15px;
}
.new-kpi-col-manage .bg-white {
    padding: 20px;
}
.new-kpi-col-manage .bg-white .control-lever {
    width: 100%;
}
.width85-mob-tab {
    width: 85%;
}
.width15-mob-tab {
    width: 15%;
}
.smallp {
    text-align: left !important;
    line-height: initial;
}
}
`;